export const REMEMBERED_USERNAME_KEY = 'optimus.remembered-username';
export const REMEMBERED_SITE_KEY = 'optimus.remembered-site';

export const SITE_VALUES = ['general', 'madrasha'] as const;

export const SITE_LABEL: Record<(typeof SITE_VALUES)[number], string> = {
  general: 'General',
  madrasha: 'Madrasha & Hons',
};

export const PASSWORD_MASK_LENGTH = 8;
export const PASSWORD_MASK_CHARACTER = '•';

export const FORGOT_PASSWORD_MESSAGE = 'Please contact your administrator to reset your password.';
